import { combineReducers } from "redux";
import betReducer from "./betReducer";
import miniReducer from "./miniReducer";
import moreReducer from "./moreReducer";
import pageReducer from "./pageReducer";
import sportsReducer from "./sportsReducer";
import userReducer from './userReducer';
export default combineReducers({
   user: userReducer,
   sports: sportsReducer,
   page: pageReducer,
   mini: miniReducer,
   bet: betReducer,
   more: moreReducer
});



// WEBPACK FOOTER //
// ./src/common/reducers/index.js